export default __webpack_public_path__ + "static/media/company_active_w.83e95334.svg";